module.exports = __webpack_public_path__ + "img/10979909_L.44d54975.png";